<template>
    <div class="app flex-row align-items-center animated fadeIn">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-4 col-md-6">
                    <div class="card-group mb-0">
                        <div class="card p-0">
                            <div class="row">
                                <div class="col-md-12" v-if="invalid_register">
                                    <div class="bg-danger text-center card">
                                        <div class="card-body">
                                            <blockquote class="card-blockquote">
                                                <p v-html="error_msg"></p>
                                            </blockquote>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12" v-if="valid_register">
                                    <div class="bg-success text-center card m-0">
                                        <div class="card-body">
                                            <blockquote class="card-blockquote m-0">
                                                <p
                                                    class="m-0"
                                                >{{ $t('Please check your email inbox for the verification mail') }}</p>
                                            </blockquote>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="!valid_register">
                                <div class="card-body">
                                    <h2>{{ $t('Register') }}</h2>
                                    <p class="text-muted">{{ $t('Register a new account') }}</p>
                                    <p class="control has-icon has-icon-right">
                                        <input
                                            name="username"
                                            type="text"
                                            v-model="form_data.username"
                                            v-validate="'required'"
                                            :class="{'form-control': true, 'is-invalid': errors.has('username')}"
                                            :placeholder="$t('Username')"
                                            autocomplete="off"
                                        />
                                        <span
                                            v-show="errors.has('username')"
                                            class="help invalid-feedback"
                                        >{{ $t(errors.first('username')) }}</span>
                                    </p>
                                    <p class="control has-icon has-icon-right">
                                        <input
                                            name="name"
                                            v-model="form_data.user_fullname"
                                            v-validate="'required'"
                                            :class="{'form-control': true, 'is-invalid': errors.has('name')}"
                                            type="text"
                                            :placeholder="$t('Full Name')"
                                            autocomplete="off"
                                        />
                                        <span
                                            v-show="errors.has('name')"
                                            class="help invalid-feedback"
                                        >{{ $t(errors.first('name')) }}</span>
                                    </p>
                                    <p class="control has-icon has-icon-right">
                                        <input
                                            name="email"
                                            v-model="form_data.user_email"
                                            v-validate="'required|email'"
                                            :class="{'form-control': true, 'is-invalid': errors.has('email')}"
                                            type="text"
                                            :placeholder="$t('Email')"
                                            autocomplete="off"
                                        />
                                        <span
                                            v-show="errors.has('email')"
                                            class="help invalid-feedback"
                                        >{{ $t(errors.first('email')) }}</span>
                                    </p>
                                    <p class="control has-icon has-icon-right">
                                        <input
                                            ref="user_password"
                                            name="user_password"
                                            v-model="form_data.user_password"
                                            v-validate="'required|min:6'"
                                            :class="{'form-control': true, 'is-invalid': errors.has('user_password')}"
                                            type="password"
                                            :placeholder="$t('Password')"
                                            autocomplete="off"
                                        />
                                        <span
                                            v-show="errors.has('user_password')"
                                            class="help invalid-feedback"
                                        >{{ $t(errors.first('user_password')) }}</span>
                                    </p>
                                    <p class="control has-icon has-icon-right">
                                        <input
                                            name="user_password_confirmation"
                                            v-validate="'required|confirmed:user_password'"
                                            v-model="form_data.user_password_confirmation"
                                            :class="{'form-control': true, 'is-invalid': errors.has('user_password_confirmation')}"
                                            type="password"
                                            :placeholder="$t('Retype the Password')"
                                            data-vv-as="user_password"
                                            autocomplete="off"
                                        />
                                        <span
                                            v-show="errors.has('user_password_confirmation')"
                                            class="help invalid-feedback"
                                        >{{ $t(errors.first('user_password_confirmation')) }}</span>
                                    </p>
                                    <div class="row">
                                        <div class="col-12">
                                            <button
                                                @click.prevent="redirect_with_loader('/user/login')"
                                                type="button"
                                                class="btn btn-default px-4 mr-2"
                                            >{{ $t('Back') }}</button>
                                            <button
                                                @click="register()"
                                                type="button"
                                                class="btn btn-primary px-4"
                                            >{{ $t('Register') }}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

import redirect from '../../mixins/redirect'
export default {
	name: 'register',
	mixins: [redirect],
	data() {
		return {
			form_data: {
				username: '',
				user_email: '',
				user_fullname: '',
				user_password: '',
				user_password_confirmation: '',
			},
			error_msg: '',
			valid_register: false,
			invalid_register: false,
		}
	},
	methods: {
		register() {
			this.invalid_register = false
			this.valid_register = false
			this.$validator
				.validateAll(['username', 'email', 'name', 'user_password', 'user_password_confirmation'])
				.then((isValid) => {
					if (isValid) {
						this.$root.loader = true
						axios
							.post('/passport/register', this.form_data)
							.then((res) => {
								if (res.data.status) {
									if (process.env.NODE_ENV != 'production' || true) {
										axios
											.post('/passport/login', {
												email: this.form_data.user_email,
												password: this.form_data.user_password,
											})
											.then((response) => {
												this.$root.loader = false
												const token = response.data.access_token
												localStorage.setItem('token', token)
												axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
												this.$router.push(this.$route.query.redirect || '/')
											})
											.catch(() => {
												this.$root.loader = false
												this.valid_register = true
											})
									} else {
										this.$root.loader = false
										this.valid_register = true
									}
								}
							})
							.catch((e) => {
								this.$root.loader = false
								this.invalid_register = true
								this.error_msg = e.message || 'The given data was invalid.'
							})
					}
				})
		},
	},
	created() {
		this.$root.loader = !true
	},
}
</script>
